import { render, staticRenderFns } from "./EditAuthorPaymentDetails.vue?vue&type=template&id=40452e59"
import script from "./EditAuthorPaymentDetails.vue?vue&type=script&lang=js"
export * from "./EditAuthorPaymentDetails.vue?vue&type=script&lang=js"
import style0 from "./EditAuthorPaymentDetails.vue?vue&type=style&index=0&id=40452e59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports